import axios from 'axios'


const URL = process.env.VUE_APP_API_ROUTE.concat(
    '/sl_service_order/ticket_next'
)
export default async ticket_number => {
    try {
        let response = await axios.get(URL, {
            params: { ticket_number: ticket_number },
        })
        console.log(response.data)
        return response.data
    } catch (error) {
        console.log(error)
        return error.response
    }
}
